<template>
    <div class="modal fade" id="forgotPasswordModal" tabindex="-1" role="dialog" aria-labelledby="forgotPasswordModal">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h1>RESET PASSWORD</h1>
                    <hr>
                </div>
                <span id="emailInputSpan"><input id="email" type="text" placeholder="E-mail address"></span>
                <button id="close-button" class="grow" @click="hideModal">CANCEL</button>
                <button id="send-email-button" class="grow" :disabled="onRequest" @click="sendEmail">SEND</button>
            </div>
        </div>
    </div>
</template>

<script>
    // import LoadingModal from '@/components/modals/LoadingModal.vue'
    import Constants from '@/utils/constants'
    import 'setimmediate';
    // import Common from '@/utils/Common.vue'

    export default {
        name: "forgotPasswordModal",
        data(){
            return {
                onRequest: false
            }
        },
        methods:{
            showModal(){
                $('#email').val('');
                $('#forgotPasswordModal').modal('show');
            },
            hideModal(){
                $('#forgotPasswordModal').modal('hide');
            },
            sendEmail(){
                var email = $('#email').val();

                if(this.validateEmail(email)){
                    this.onRequest = true;
                    var data = {
                        email: email
                    }

                    this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + '/enterprise/forgotpassword/sent', data)
                        .then(response => {
                            this.hideModal();
                            this.onRequest = false;
                            this.$toasted.show("Your request will be reviewed and new activation link will be delivered to your e-mail.", {
                                position: "bottom-center",
                                duration: 5000,
                                type: 'success'
                            });
                        }, response => {
                            this.onRequest = false;
                            this.$toasted.show("Email could not sent, please try again later.", {
                                position: "bottom-center",
                                duration: 5000,
                                type: 'error'
                            });
                        });

                }
                else{
                    this.$toasted.show("Email adress is not valid, please try again!", {
                        position: "bottom-center",
                        duration: 5000,
                        type: 'error'
                    });
                }
            },
            validateEmail(email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
        },
        mounted() {
            $('#forgotPasswordModal').modal({show: false});
        }
    }
</script>

<style scoped>
    hr{
        display: block;
        height: 1px;
        border: 0;
        border-top: 2px solid #4A4F53;
        margin: 1em 0;
        padding: 0;
        width: 100%;
    }
    #emailInputSpan{
        color: #f8fdff;
    }

    #email{
        width: 75%;
        height: 38px;
        font-size: 17px;
        border: 1px solid #4A4F53;
        font-family: 'Digital-Serial-Bold' !important;
        margin-left: 12.5%;
        background-color: #1f262b;
        margin-top: 25px;
        margin-bottom: 25px;
        text-align: center;
    }

    #email::placeholder{
        color: #f8fdff;
    }

    #close-button{
        background-color: rgba(255, 0, 67, 1);
        border:none;
        height: 70px;
        width: 170px;
        color: #1F262B;
        padding: 0 15px;
        font-family: 'Digital-Serial-Bold' !important;
        position: absolute;
        left: calc(49% - 200px);
        bottom: 10%;
        font-size: large;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        border-radius: 10px;
    }

    #send-email-button {
        background-color: #00ffaa;
        border:none;
        height: 70px;
        width: 170px;
        color: #1F262B;
        padding: 0 15px;
        font-family: 'Digital-Serial-Bold' !important;
        position: absolute;
        right: 15%;
        bottom: 10%;
        font-size: large;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        border-radius: 10px;
    }

    .modal-header{
        border-bottom: 1px solid #1f262b !important;
    }

    .modal-dialog {
        border: 2px solid #4A4F53;
        height: 35% !important;
        width: 33% !important;
    }

    .modal-content {
        height: 100% !important;
        background-color: #1f262b !important;
        position: relative;
    }

    h1{
        padding-left: 10px;
        color: #f8fdff;
        font-family: 'Digital-Serial-Bold' !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/modals/ForgotPasswordModal.vue